import React from 'react';
import {
    FormattedMessage,
    FormattedNumber,
    WrappedComponentProps,
    injectIntl,
    useIntl,
} from 'react-intl';
import Modal, { IModalChildProps } from '../../common/modal';
import { ICartItemInfo } from '../../../models/pro-sites';
import { IPatient } from '../../../models/prosites';

interface IDeleteModal extends IModalChildProps {
    item: ICartItemInfo;
}

const DeleteModal = ({ item, onAccept, onClose }: IDeleteModal) => {
    const intl = useIntl();
    const getPatientDetails = (patient: IPatient | null) => {
        return patient ? (
            <>
                <div>
                    <span>
                        <FormattedMessage id="Patient_Order" />
                    </span>
                </div>
                <div>
                    <span>{patient.lastName + ', ' + patient.firstName}</span>
                </div>
            </>
        ) : (
            <div>
                <span>
                    <FormattedMessage id="Stock_Order" />
                </span>
            </div>
        );
    };

    return (
        <Modal>
            <>
                <div className="modal-header">
                    <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label={intl.formatMessage({ id: 'Close' })}
                        onClick={onClose}
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 className="modal-title">
                        <FormattedMessage id="Are_you_sure_you_want_to_delet" />
                    </h4>
                    <div className="row" style={{ marginTop: '10px' }}>
                        <div className="col-md-3">
                            <img
                                alt={item.description}
                                style={{
                                    width: '100px',
                                    height: '100px',
                                    paddingTop: '5px',
                                }}
                                src={item.imageUrl}
                            />
                        </div>
                        <div className="col-md-9">
                            <div
                                style={{
                                    fontWeight: 'bold',
                                    marginBottom: '10px',
                                }}
                            >
                                {item.description}
                            </div>
                            {item.partNumber && (
                                <div>
                                    <FormattedMessage id="Part_Number" />:{' '}
                                    {item.partNumber}
                                </div>
                            )}
                            <div>
                                <FormattedMessage id="Quantity" />:{' '}
                                <FormattedNumber value={item.quantity} />
                            </div>
                            <div>{getPatientDetails(item.patient)}</div>
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <button className="btn btn-info" onClick={onAccept}>
                        <FormattedMessage id="Delete" />
                    </button>
                    <button
                        type="button"
                        className="btn btn-default"
                        onClick={onClose}
                    >
                        <FormattedMessage id="Cancel" />
                    </button>
                </div>
            </>
        </Modal>
    );
};

export default DeleteModal;
